// extracted by mini-css-extract-plugin
export var content = "signUpSectionCard-module--content--3RqLM";
export var card = "signUpSectionCard-module--card--W3JxZ";